import { combineReducers } from 'redux';
import {
  RECEIVED_PROPOSALS,
  FETCH_PROPOSALS,
  RECEIVED_PROPOSAL,
  RECEIVED_PROPOSALS_STATISTICS,
} from '../actions/proposal';

const ids = (state = [], action) => {
  switch (action.type) {
    case RECEIVED_PROPOSALS:
      return action.payload.data.map((p) => p.id);
    default:
      return state;
  }
};

const entities = (state = [], action) => {
  switch (action.type) {
    case RECEIVED_PROPOSALS:
      return action.payload.data;
    default:
      return state;
  }
};

const entitiesCount = (state = 0, action) => {
  switch (action.type) {
    case RECEIVED_PROPOSALS:
      return action.payload.total;
    default:
      return state;
  }
};

const currentPage = (state = 1, action) => {
  switch (action.type) {
    case RECEIVED_PROPOSALS:
      return action.payload.page;
    default:
      return state;
  }
};

const dataPerPage = (state = 10, action) => {
  switch (action.type) {
    case RECEIVED_PROPOSALS:
      return action.payload.perPage;
    default:
      return state;
  }
};

const lastPage = (state = 1, action) => {
  switch (action.type) {
    case RECEIVED_PROPOSALS:
      return action.payload.lastPage;
    default:
      return state;
  }
};

const currentSelected = (state = {}, action) => {
  switch (action.type) {
    case RECEIVED_PROPOSAL:
      return action.payload;
    default:
      return state;
  }
};

const isFetchingProposals = (state = false, action) => {
  switch (action.type) {
    case FETCH_PROPOSALS:
      return true;
    case RECEIVED_PROPOSALS:
      return false;
    default:
      return state;
  }
};

const statistics = (state = {}, action) => {
  switch (action.type) {
    case RECEIVED_PROPOSALS_STATISTICS:
      return action.payload;
    default:
      return state;
  }
};

export default combineReducers({
  ids,
  entities,
  currentSelected,
  currentPage,
  lastPage,
  dataPerPage,
  isFetchingProposals,
  statistics,
  entitiesCount,
});
